import React, { Fragment } from "react";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  NativeSelect,
  Divider,
} from "@material-ui/core";
import { palette } from "configurations/styles/theme";
import { tipoContribuyente } from "views/facturacion/Forms/typeVoucher";
import useMultipleRucs, {
  BootstrapInput,
} from "hooks/useRucsAuthorizedMethods";

const MultipleRucs = ({
  rucsAutorizados,
  setRucsAutorizados,
  viewPago,
  setViewPago,
  totals,
}) => {
  const {
    setRuc,
    classes,
    classesApp,
    classesGlobal,
    open,
    ruc,
    empty,
    handleClickOpen,
    handleClose,
    handleAddRuc,
    handleChangeUniversal,
  } = useMultipleRucs(
    rucsAutorizados,
    setRucsAutorizados,
    viewPago,
    setViewPago,
    totals
  );

  return (
    <Fragment>
      <Grid container justify="center" className={classes.divButton}>
        <Button variant="outlined" color="primary" onClick={handleClickOpen}>
          Agregar ruc autorizado
        </Button>
      </Grid>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">Nuevo RUC </DialogTitle>
        <DialogContent>
          <form>
            <Grid container>
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>

              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  RUC <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  type="text"
                  placeholder="Ej. 17242145863"
                  name="ruc"
                  value={ruc.ruc}
                  onChange={handleChangeUniversal}
                  autoComplete="off"
                  className={
                    ruc
                      ? ruc.ruc
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />
                {empty.ruc != null &&
                  <p className={classesApp.errorLetters}>{empty.ruc}</p>
                }
              </Grid>

              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  Tipo de Contribuyente:{" "}
                  <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <FormControl className={classesGlobal.select}>
                  <NativeSelect
                    value={ruc.tipoRuc}
                    name="tipoRuc"
                    onChange={handleChangeUniversal}
                    input={<BootstrapInput />}
                  >
                    <option aria-label="None" value="">
                      --Seleccione--
                    </option>
                    {tipoContribuyente.map((element) => (
                      <option key={element.CODIGO} value={element.CODIGO}>
                        {element.NOMBRE}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
                {empty.tipoRuc != null &&
                  <p className={classesApp.errorLetters}>{empty.tipoRuc}</p>
                }
              </Grid>
              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>Dígito verificador: </label>
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  type="text"
                  name="dv"
                  value={ruc.dv}
                  onChange={handleChangeUniversal}
                  autoComplete="off"
                  className={
                    ruc
                      ? ruc.dv
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />
                {empty.dv != null &&
                  <p className={classesApp.errorLetters}>{empty.dv}</p>
                }
              </Grid>

              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider />
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddRuc}
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default MultipleRucs;
